class RelatedProducts extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector('[data-related-products]');
    if (!container) return;

    fetch(container.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = doc.querySelector('.ki-related-products');
        if (recommendations) {
          this.innerHTML = recommendations.outerHTML;
        } else {
          this.remove();
        }
      })
      .catch(() => this.remove());
  }
}

customElements.define('related-products', RelatedProducts);
